var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 582.4 392.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke: #405391;\n      }\n\n      .cls-1, .cls-2, .cls-8, .cls-9 {\n        fill: none;\n      }\n\n      .cls-1, .cls-4, .cls-6 {\n        stroke-linejoin: round;\n      }\n\n      .cls-2, .cls-3, .cls-8, .cls-5, .cls-7 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #0463ef;\n      }\n\n      .cls-4, .cls-5, .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        stroke: #fff;\n        stroke-width: 2px;\n      }\n\n      .cls-10 {\n        fill: #405391;\n      }\n\n      .cls-6 {\n        stroke-linecap: round;\n      }\n\n      .cls-7 {\n        fill: #8fb6ff;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    width: 582.4,
    height: 392.25,
    rx: 18.76,
    ry: 18.76
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M543.59,216.72c-8.21-14.1-5.06-43.78-5.06-43.78l-1.85,1.69c8.23-21.52,1.34-30.21,1.34-30.21-20.31-30.23-50.71-10.24-50.71-10.24,0,0-22.3,3.56-14.05,30.22,.5,1.62,.71,3.59,.77,5.65-.07,.24-3.51,12.88-4.74,15.25-.89,1.72,3.58,4.09,6.17,5.29,5.78,25.23,7.08,24.34,7.08,24.34,10.21,.49,18.34-1.18,24.92-4.14,.91,4.75,1.84,9.85,1.84,9.85,2.19,17.37-22.33,28.55-22.33,28.55l46.55,17.58,46.25-29.51s-26.16-3.36-36.17-20.54Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "310.8 371.7 466.4 357.56 556.8 382.81 557.22 389.24 401.62 403.38 311.22 378.13 310.8 371.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "315.02 372.29 467.47 363.35 444.16 267.73 444.16 267.73 295.15 274.68 315.02 372.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M376.3,274.46c.24,1.05-.29,2.06-1.18,2.26-.89,.2-1.81-.48-2.05-1.53-.24-1.05,.29-2.06,1.18-2.26,.89-.2,1.81,.48,2.05,1.53Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "295.15 274.68 444.16 267.73 295.15 274.68 315.02 372.29 310.81 371.87 292.33 277.64 295.15 274.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "306.68 282.46 437 276.31 454.35 351.88 323.52 363.62 306.68 282.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "310.8 371.7 401.2 396.95 556.8 382.81 466.4 357.56 310.8 371.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "377.93 386.3 332.87 373.71 466.03 361.61 509.8 373.84 377.93 386.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 342.47,
    y1: 376.4,
    x2: 476.11,
    y2: 364.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 353.7,
    y1: 379.56,
    x2: 487.33,
    y2: 367.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 364.92,
    y1: 382.72,
    x2: 498.55,
    y2: 370.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 348.98,
    y1: 372.42,
    x2: 393.13,
    y2: 384.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 363.91,
    y1: 371.12,
    x2: 408.06,
    y2: 383.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 376.74,
    y1: 369.87,
    x2: 420.89,
    y2: 382.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 389.56,
    y1: 368.62,
    x2: 433.71,
    y2: 380.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 402.39,
    y1: 367.37,
    x2: 446.53,
    y2: 379.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 415.79,
    y1: 366.28,
    x2: 459.36,
    y2: 378.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 428.56,
    y1: 365.02,
    x2: 472.57,
    y2: 377.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 441.62,
    y1: 363.83,
    x2: 485.41,
    y2: 376.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 454.88,
    y1: 362.7,
    x2: 498.22,
    y2: 374.76
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M378.17,292.65l48.92-2.94c.39-.02,.73,.24,.83,.62l4.87,19.55c.12,.49-.22,.97-.72,1.01l-40.28,2.96c-.18,.02-.35,.09-.48,.21l-6.17,7.13c-.48,.43-1.24,.17-1.35-.47l-6.38-27.1c-.09-.49,.27-.95,.77-.97Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "385.57 329.49 435.91 325.61 439.27 337.2 436.93 337.45 434.64 337.7 388.57 341.83 385.57 329.49"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "376.56 341.75 365.36 293 330.29 294.46 325.28 297.73 335.88 348.84 371.55 345.03 376.56 341.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "330.29 294.46 365.36 293 376.56 341.75 340.89 345.56 330.29 294.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 335.88,
    y1: 348.84,
    x2: 340.89,
    y2: 345.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M353.42,293.5l1.86,9.99c.05,.26,.39,.33,.54,.11l1.59-2.35c.12-.18,.37-.21,.54-.07l2.18,1.84c.22,.18,.54-.01,.48-.29l-2.09-9.44-5.09,.21Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 342.14,
    y1: 315.42,
    x2: 364.14,
    y2: 313.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 342.86,
    y1: 320.14,
    x2: 364.87,
    y2: 318.43
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 396.31,
    y1: 298.74,
    x2: 403.71,
    y2: 298.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 396.54,
    y1: 302,
    x2: 424.05,
    y2: 300.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 396.98,
    y1: 305.43,
    x2: 424.49,
    y2: 304
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M392.1,302.03c.52,2.29-.64,4.51-2.59,4.95-1.95,.45-3.96-1.05-4.48-3.34-.52-2.29,.64-4.51,2.59-4.95,1.95-.45,3.96,1.05,4.48,3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M391.92,333.63c.13,.58-.16,1.14-.66,1.26-.5,.11-1-.27-1.14-.85-.13-.58,.16-1.14,.66-1.26,.5-.11,1,.27,1.14,.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M395.54,333.22c.13,.58-.16,1.14-.66,1.26-.5,.11-1-.27-1.14-.85-.13-.58,.16-1.14,.66-1.26,.5-.11,1,.27,1.14,.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M399.17,332.81c.13,.58-.16,1.14-.66,1.26-.5,.11-1-.27-1.14-.85-.13-.58,.16-1.14,.66-1.26,.5-.11,1,.27,1.14,.85Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M578.23,245.71s-2.03-11-3.13,27.45c-1.02,35.99-1.42,73.76-1.42,73.76,0,0-19.5,.57-40.37,9.68l-13.51,5.61s35.07,19.42,60.03,27.18c22.98,7.14,25.14-10.41,22.4-53.05,0,0-13.07-87.59-24.01-90.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M486,124.83s-29.3,15.63-12.53,31.32l19.91-19.9-7.38-11.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M529.81,199.71s6.59-.17,10.53,8.75c0,0-4.32-10.13,3.22-18.51l-13.74,9.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M486,124.83s-35.84,35.1-14.36,25.26c44.88-20.55,42.58,31.23,42.58,31.23,0,0,6.18-5.63,3.9,.26l11.69,18.12s24.99-9.45,26.32-40.92c.45-10.63-10-59.37-70.13-33.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M501.38,145.65c.67,5.37,0,26.82,9.48,28.39,9.48,1.57-1.63-26.93-1.63-26.93l-7.85-1.46Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M471.28,260.91c-11.35,51.01-16.6,103.71-16.6,103.71,0,0-22.42-6.36-43.69-9.8l-23.24-6.24c-.75-.34-8.81-4.06-11.42-6.64-2.74-2.72-4.25,4.76,.06,8.17,1.3,1.03,2.31,1.94,3.13,2.73l-5.6,.87c-.96,.15-1.86,.57-2.58,1.23-3.9,3.53-16.62,15.28-14.21,16.01,.6,.18,1.27,.19,2,.08-4.35,3.59-4.69,7.34-3.48,7.46,1.82,.19,4.12-1.12,6.41-2.97-2.01,2.33-4.51,7.47-1.72,7.34,3.74-.17,6.88-3.08,9.87-8,0,0-.74,1.28-.41,.98l-2.22,3.59s4.52,3.97,7.81,5.82c3.14,1.76,4.97-4.72,.53-7.39,0,0,1.6-1.6,2.89-5.01,0,0,12.47,6.03,18.84,1.25l4.17,.4c10.89,6.82,66.2,31.68,73.78,31.11,17.21-1.28,20.48-35.12,28.8-109.08,0,0-28.04-58.51-33.12-35.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M454.68,364.62s-5.36,2.85-6.44,10.77"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M590.49,336.07c8.87-1.47,23.19-6.37,23.2-6.42,0,0-5.49-69.19-22.95-89.68-.89-1.91-3.82-5.86-13.19-7.24-2.78-.41-5.51-.92-8.13-1.48,0,0,0,0,0,0-9.16-1.97-16.62-4.71-18.75-6.06,0,0,.01,.08,.03,.21-.05-.03-.11-.06-.16-.09,0,0,.42,1.85-.24,4.01-.06,.19-.12,.38-.2,.58-.03,.08-.07,.17-.11,.25-.14,.31-.29,.63-.48,.94h0c-2.86,4.72-21.83,6.62-40.79-3.4,0,0-32.57,18.47-41.25,24.88-13.32,28.38-19.04,92.47-19.04,89.49,0-.81,27.14,13.41,44.78,14.18,.1,5.03-4.32,68.56-4.32,68.56,0,0,76.7,3.92,110.68-14.16,0,0-13.39-44.61-11.82-57.06,.19-1.47,2.33-13.88,2.7-17.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M489.14,124.42s-37.56-8.76-35.2,.91,12.08,18.11,12.08,18.11c0,0-11.07-.28-5.26,5.34,5.81,5.62,10.67,5.2,10.67,5.2l17.71-29.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M507.46,210.79s3.86-.97,10.95-7.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M514.38,165.29s-2.61-48.4-28.05-42.46"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 513.68,
    cy: 178.19,
    rx: 16.3,
    ry: 15.9,
    transform: "translate(302.82 679.35) rotate(-86.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M524.41,178.65c-.42,6.45-5.58,11.37-11.54,10.99-5.96-.38-10.45-5.93-10.04-12.38,.42-6.45,5.58-11.37,11.54-10.99,5.96,.38,10.45,5.93,10.04,12.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M478.77,173.52c.01,1.3,.83,2.35,1.83,2.34,1,0,1.8-1.07,1.79-2.37-.01-1.3-.83-2.35-1.83-2.34-1,0-1.8,1.07-1.79,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M487.61,166.68c-1.46-2-3.53-2.71-5.18-3.24-1.83-.59-3.63-1.18-4.4-.33-.46,.51-.49,1.47-.09,2.07,.55,.85,1.79,.81,2.95,.93,4.49,.47,7.06,3.16,7.57,2.5,.29-.38-.45-1.39-.84-1.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M479.1,196.9s4.93-.2,8.14-3.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M460.41,117.41c.33-.04,15.13-4.07,26.34,8.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M549.17,126.52l-1.14,11.54s2.97-5.72,8.86-1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M475.17,139.04s-12.55,17.73-6.15,17.7c9.67-.05,19.23-12.62,17.48-13.27-1.75-.65-11.33-4.42-11.33-4.42Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "362.06 375.52 366.98 365.1 372.3 360.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 359.12,
    y1: 371.03,
    x2: 364.82,
    y2: 364.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "379.5 362.17 373.14 366.68 369.8 375.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M467.5,252.57s40.5-10.02,39.6,41.28l-1.86,61.5s-7.56,1.56-15.42,.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 379.51,
    y1: 352.83,
    x2: 386.46,
    y2: 351.84
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 236.92,
    y1: 373.59,
    x2: 311.22,
    y2: 373.59
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M454.68,214.88c0,1.36-1.1,2.46-2.46,2.46s-2.46-1.1-2.46-2.46,1.1-2.46,2.46-2.46,2.46,1.1,2.46,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M570.84,196.97c0,1.36-1.1,2.46-2.46,2.46s-2.46-1.1-2.46-2.46,1.1-2.46,2.46-2.46,2.46,1.1,2.46,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M426.42,138.73c0,1.36-1.1,2.46-2.46,2.46s-2.46-1.1-2.46-2.46,1.1-2.46,2.46-2.46,2.46,1.1,2.46,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M337.4,209.97c0,1.36-1.1,2.46-2.46,2.46s-2.46-1.1-2.46-2.46,1.1-2.46,2.46-2.46,2.46,1.1,2.46,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M402.38,185.65c3.15-.17,5.65-2.76,5.65-5.95s-2.67-5.96-5.96-5.96c-.6,0-1.18,.09-1.73,.26-1.01-4.16-4.75-7.26-9.23-7.26s-8.15,3.04-9.2,7.15c-.42-.1-.86-.15-1.31-.15-3.29,0-5.96,2.67-5.96,5.96s2.42,5.7,5.49,5.94h22.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M433.05,82.61c3.28-.17,5.89-2.88,5.89-6.21s-2.79-6.22-6.23-6.22c-.63,0-1.23,.09-1.8,.27-1.06-4.35-4.96-7.58-9.63-7.58s-8.51,3.18-9.61,7.47c-.44-.1-.9-.16-1.37-.16-3.44,0-6.23,2.79-6.23,6.22s2.53,5.95,5.73,6.2h23.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 532.76,
    y1: 61.62,
    x2: 532.76,
    y2: 64.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 523.76,
    y1: 66.59,
    x2: 526.21,
    y2: 68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 523.56,
    y1: 76.86,
    x2: 526,
    y2: 75.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 532.36,
    y1: 82.18,
    x2: 532.36,
    y2: 79.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 541.36,
    y1: 77.21,
    x2: 538.92,
    y2: 75.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 541.56,
    y1: 66.94,
    x2: 539.12,
    y2: 68.35
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 364.87,
    y1: 105.14,
    x2: 364.87,
    y2: 107.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 355.87,
    y1: 110.1,
    x2: 358.32,
    y2: 111.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 355.67,
    y1: 120.38,
    x2: 358.12,
    y2: 118.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 364.47,
    y1: 125.69,
    x2: 364.47,
    y2: 122.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 373.47,
    y1: 120.73,
    x2: 371.03,
    y2: 119.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 373.67,
    y1: 110.45,
    x2: 371.23,
    y2: 111.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 385.17,
    y1: 223.91,
    x2: 385.17,
    y2: 226.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 376.17,
    y1: 228.87,
    x2: 378.61,
    y2: 230.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 375.97,
    y1: 239.15,
    x2: 378.41,
    y2: 237.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 384.77,
    y1: 244.46,
    x2: 384.77,
    y2: 241.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 393.77,
    y1: 239.5,
    x2: 391.32,
    y2: 238.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 393.97,
    y1: 229.22,
    x2: 391.52,
    y2: 230.63
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 234.1,
    cy: 342.49,
    rx: 19.89,
    ry: 3.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M229.15,379.56h9.92c3.69-.21,6.78-.64,8.71-1.2l5.51-35.74h-.06c0,1.64-8.56,2.97-19.12,2.97s-19.12-1.33-19.12-2.97h-.06l5.51,35.74c1.93,.56,5.01,1,8.71,1.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M206.27,299.9c-7.88,0-14.27,6.39-14.27,14.27,0,1.29,.19,2.54,.51,3.73,.44-.22,.93-.35,1.46-.35,1.85,0,3.34,1.5,3.34,3.34,0,1.21-.64,2.26-1.6,2.84,2.61,2.88,6.37,4.69,10.56,4.69,7.88,0,14.27-6.39,14.27-14.27s-6.39-14.27-14.27-14.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M216.89,310.23c0,1.09-.88,1.97-1.97,1.97s-1.97-.88-1.97-1.97,.88-1.97,1.97-1.97,1.97,.88,1.97,1.97Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 255.57,
    cy: 304.82,
    r: 14.27,
    transform: "translate(-140.41 342.72) rotate(-55.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.7,304.99s-20.52,11.93-18.81,35.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M227.5,300.35c5.61,5.53,14.64,5.47,20.17-.14,5.53-5.61,5.47-14.64-.14-20.17-5.61-5.53-14.64-5.47-20.17,.14-5.53,5.61-5.47,14.64,.14,20.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.9,290.83s-14.27,35.28-1.11,52.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.76,314.17s22.44,7.72,25.39,31.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M250.39,310.89c7.88,0,14.27,6.39,14.27,14.27,0,1.29-.19,2.54-.51,3.73-.44-.22-.93-.35-1.46-.35-1.85,0-3.34,1.5-3.34,3.34,0,1.21,.64,2.26,1.6,2.84-2.61,2.88-6.37,4.69-10.56,4.69-7.88,0-14.27-6.39-14.27-14.27s6.39-14.27,14.27-14.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239.77,321.22c0,1.09,.88,1.97,1.97,1.97s1.97-.88,1.97-1.97-.88-1.97-1.97-1.97-1.97,.88-1.97,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.29,322.04s-15.84,6.3-19.73,22.82"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M316.89,370.75c.73,2.47-.31,4.95-2.32,5.54-2.01,.59-4.23-.93-4.95-3.39-.73-2.47,.31-4.95,2.32-5.54,2.01-.59,4.23,.93,4.95,3.39Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.9,100.86c-13.89,1.06-25.27,12.09-26.74,25.94-.57,5.44,.36,10.61,2.42,15.16,.39,.86,.41,1.83,.12,2.72l-2.88,8.9c-.54,1.68,.97,3.3,2.68,2.87l8.39-2.1c.99-.25,2.05-.12,2.92,.42,5.09,3.16,11.22,4.81,17.77,4.28,14.14-1.13,25.59-12.59,26.7-26.73,1.41-17.96-13.43-32.83-31.38-31.47Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280.58,126.61v10.99s-2.99,4.34-12.93,4.34-12.93-4.34-12.93-4.34v-10.99"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 277.05,
    y1: 128.46,
    x2: 277.05,
    y2: 145.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.33,132.78l-19.54-8.31c-.68-.29-.65-1.26,.04-1.51l19.54-7.25c.18-.07,.38-.07,.57,0l19.54,7.25c.69,.26,.71,1.22,.04,1.51l-19.54,8.31c-.2,.09-.43,.09-.64,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M277.05,148.41c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5,1.5,.67,1.5,1.5-.67,1.5-1.5,1.5Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero-bg.b1380df1e5126356a8b494dc47653f23.svg";
export { ForwardRef as ReactComponent };